export const _data_ner = {
  "input_text": "ร่วมกันสอบปากคำและแถลงข่าวผลการจับกุมแก๊งเงินกู้ ประกอบด้วย นายชาญชัย หรือชาญ เววิชัยโก อายุ 23 ปี",
  "tokens": [
      {"entity": "O", "token": "ร่วมกัน"},
      {"entity": "O", "token": "สอบปากคำ"},
      {"entity": "O", "token": "และ"},
      {"entity": "O", "token": "แถลงข่าว"},
      {"entity": "O", "token": "ผล"},
      {"entity": "O", "token": "การจับกุม"},
      {"entity": "O", "token": "แก๊ง"},
      {"entity": "O", "token": "เงินกู้"},
      {"entity": "O", "token": "ประกอบด้วย"},
      {"entity": "B-PERSON", "token": "นาย"},
      {"entity": "I-PERSON", "token": "ชาญ"},
      {"entity": "I-PERSON", "token": "ชัย"},
      {"entity": "O", "token": "หรือ"},
      {"entity": "B-PERSON", "token": "ชาญ"},
      {"entity": "I-PERSON", "token": "เว"},
      {"entity": "I-PERSON", "token": "วิชัย"},
      {"entity": "I-PERSON", "token": "โก"},
      {"entity": "O", "token": "อายุ"},
      {"entity": "B-TIME", "token": "23"},
      {"entity": "I-TIME", "token": "ปี"},
  ],
  "type": "ner",
};

export const _data_summary = 
{
  "input_text": "จากกรณีเหตุลุงหัวร้อนใช้อาวุธปืนยิง น.ส.สุจิตรา อายุ 35 ปี เสียชีวิต และยิง น.ส.จิราภา อายุ 32 ปี รวมถึงชายไม่ทราบชื่อ อายุประมาณ 25 ปี ได้รับบาดเจ็บ ภายในซอยสิงหเจริญอุทิศ 4 แยกซอยสมเด็จพระเจ้าตากสิน 18 แขวงบุคคโล เขตธนบุรี กรุงเทพฯ เมื่อเวลาประมาณ 23.30 น. ของเมื่อคืนที่ผ่านมาความคืบหน้าคดี เมื่อเวลา 11.30 น. พนักงานสอบสวนรวบรวมพยานหลักฐานยื่นคำร้องต่อศาลอาญาธนบุรี พิจารณาออกหมายจับลุงหัวร้อน พร้อมพวกรวม 2 คน โดยศาลพิจารณาอนุมัติออกหมายจับที่ 88/2565 ลงวันที่ 13 ก.พ.2565 ให้จับ นายเสมา อายุ 50 ปี และ หมายจับที่ 89/2565 ลงวันที่ 13 ก.พ.2565 ให้จับ นายภานุสรณ์ อายุ 30 ปี ในข้อหาร่วมกันฆ่าผู้อื่นโดยเจตนาต่อมาเวลา 14.14 น. พลตำรวจตรีมานพ สุคนธ์ธนพัฒน์ ผบก.น.8 เข้าจับกุมนายเสมา ขจรพันธ์ อายุ 50 ปี ผู้ก่อเหตุยิง น.ส.สุจิตรา เสียชีวิต โดยพลตำรวจตรีมานพ สุคนธ์ธนพัฒน์ ผบก.น.8 เปิดเผยว่า ในเบื้องต้น เป็นการจับกุมผู้ต้องหาตามหมายจับ เนื่องจากมีพยานหลักฐานเพียงพอให้ศาลเชื่อได้ว่า ผู้ก่อเหตุมีความผิดจริง ถึงแม้ผู้ต้องหามาพบพนักงานสอบสวน แต่เมื่อมีหมายจับแล้ว ก็ต้องถือว่าเป็นการจับกุมตามหมายจับ เบื้องต้นตั้งข้อหาร่วมกันฆ่าผู้อื่นโดยเจตนา และความผิดเกี่ยวกับ พ.ร.บ.อาวุธปืน ภายหลังเจ้าหน้าที่ตำรวจนำตัวผู้ต้องหาทั้งสองคนเข้าไปสอบปากคำภายในห้องสอบสวนนานเกือบ 1 ชั่วโมง ผู้บังคับการตำรวจนครบาล 8 ให้ข้อมูลว่า ผู้ต้องหาให้การรับสารภาพว่าเป็นผู้ก่อเหตุยิงผู้เสียชีวิตจริง โดยอาวุธปืนที่ใช้เป็นอาวุธปืนที่ไม่มีทะเบียน และนำมาเก็บรักษาไว้ที่บ้านที่เกิดเหตุ โดยผู้ต้องหาและผู้เสียชีวิตมีการท้าทาย และนัดหมายจะนำหลานสาวมาส่งให้ที่บ้าน ในวันเกิดเหตุเมื่อฝั่งผู้เสียชีวิตมาถึงก็มีปากเสียงทะเลาะวิวาทกัน จนเกิดการชุลมุนกันขึ้น แต่ก็แยกย้ายกัน กระทั่งผู้เสียชีวิตออกจากบ้านไป ผู้ต้องหาพบว่าตัวเองถูกแทงเข้าที่ท้องด้านซ้าย จึงให้ผู้ต้องหาอีก 1 คนซึ่งเป็นคนขี่รถจักรยานยนต์พาไปส่งโรงพยาบาล และอ้างว่าเกรงจะถูกฝั่งของผู้เสียชีวิตรุมทำร้าย จึงพกอาวุธปืนไปด้วย เมื่อพบผู้เสียชีวิตยืนอยู่ที่หน้าปากซอยจึงเกิดความรู้สึกแค้นที่โดนทำร้าย จึงใช้อาวุธปืนยิงผู้เสียชีวิต ก่อนจะหลบหนีไป ก่อนจะนำอาวุธปืนไปโยนทิ้งที่คลองห่างจากจุดเกิดเหตุ และไปหาที่ตั้งหลักเพื่อต่อสู้คดีทั้งนี้เมื่อชุดสอบสวนถามถึงประเด็นเกี่ยวข้องกับความสัมพันธ์ในครอบครัวและหลานสาว ผู้ต้องหาก็ปล่อยโฮร้องไห้ฟูมฟายด้วยความน้อยเนื้อต่ำใจ เพราะหลานสาวไม่รัก ไม่เชื่อฟัง ติดเพื่อนและหนีออกจากบ้านไปอยู่บ้านคนอื่น ยอมรับว่าที่ผ่านมาได้มีการลงโทษหลานสาวแต่เป็นด้วยความรักและเป็นห่วงใย ไม่ใช่การทำร้ายร่างกายอย่างที่คู่กรณีกล่าวอ้างเบื้องต้นตำรวจได้แจ้งข้อกล่าวหาร่วมกันฆ่าผู้อื่นโดยเจตนา ส่วนข้อหาที่เกี่ยวข้องกับอาวุธปืนที่ไม่มีทะเบียน ชุดสืบสวนสอบสวนจะรอให้เจ้าหน้าที่งมปืนกระบอกดังกล่าวขึ้นมาได้เสียก่อน และเมื่อตรวจสอบว่าเป็นจริงตามคำให้การก็จะแจ้งข้อกล่าวหาเพิ่มอีกหนึ่งข้อหา ทั้งนี้คดีดังกล่าวมีผู้ต้องหาที่ถูกออกหมายจับ 2 คน คือตัวผู้ลงมือและผู้ขี่รถจักรยานยนต์อีก 1 คน ซึ่งในชั้นการสืบสวนสอบสวนในชั้นนี้ยังไม่พบว่ามีบุคคลอื่นเข้ามามีส่วนเกี่ยวข้อง",
  "tokens": [
      {
          "pos": "ADP",
          "role": null,
          "token": "จาก"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "กรณี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เหตุ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ลุง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หัว"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "ร้อน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ใช้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อาวุธ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ยิง"
      },
      {
          "pos": "NOUN",
          "role": "victim",
          "token": "น.ส.สุจิตรา "
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ยิง"
      },
      {
          "pos": "NOUN",
          "role": "victim",
          "token": " น.ส.จิราภา "
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "32"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปี"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "รวมถึง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ชาย"
      },
      {
          "pos": "PART",
          "role": null,
          "token": "ไม่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ทราบ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ชื่อ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อายุ"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "ประมาณ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "25"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ได้รับบาดเจ็บ"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ภายใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ซอย"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "สิงห"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เจริญ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อุทิศ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "4"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "แยก"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ซอย"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "สมเด็จพระเจ้าตากสิน"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "18"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "แขวง"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "บุคคโล"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เขต"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "ธนบุรี"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "กรุงเทพฯ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เมื่อ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เวลา"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "ประมาณ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "23.30"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "น."
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ของ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เมื่อคืน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ที่ผ่านมา"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ความคืบหน้า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คดี"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เมื่อ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เวลา"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "11.30"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "น."
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พนักงานสอบสวน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "รวบรวม"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พยานหลักฐาน"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "ยื่นคำร้อง"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ต่อ"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "ศาลอาญา"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "ธนบุรี"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พิจารณา"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ออกหมายจับ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ลุง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หัว"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "ร้อน"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "พร้อม"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พวก"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "รวม"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "2"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คน"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "โดย"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "ศาล"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พิจารณา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "อนุมัติ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ออกหมายจับ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "88"
      },
      {
          "pos": "PUNCT",
          "role": null,
          "token": "/"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "2565"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ลงวันที่"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "13"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ก.พ."
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "2565"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ให้"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "จับ"
      },
      {
          "pos": "NOUN",
          "role": "subject",
          "token": "นายเสมา"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อายุ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "50"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปี"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หมายจับ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "89"
      },
      {
          "pos": "PUNCT",
          "role": null,
          "token": "/"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "2565"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ลงวันที่"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "13"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ก.พ."
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "2565"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ให้"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "จับ"
      },
      {
          "pos": "NOUN",
          "role": "subject",
          "token": "นายภานุสรณ์"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อายุ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "30"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปี"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ข้อหา"
      },
      {
          "pos": "NOUN",
          "role": "charge",
          "token": "ร่วมกันฆ่าผู้อื่นโดยเจตนา"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เวลา"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "14.14"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "น."
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พลตำรวจตรี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "มานพ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "สุคนธ์"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ธน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พัฒน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "์"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผบ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ก."
      },
      {
          "pos": "PUNCT",
          "role": null,
          "token": "น."
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "8"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เข้า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "จับกุม"
      },
      {
          "pos": "NOUN",
          "role": "subject",
          "token": "นายเสมา ขจรพันธ์"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อายุ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "50"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ก่อเหตุ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ยิง"
      },
      {
          "pos": "NOUN",
          "role": "victim",
          "token": "น.ส.สุจิตรา "
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พลตำรวจตรี"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "มานพ"
      },
      {
          "pos": "PROPN",
          "role": null,
          "token": "สุคนธ์"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ธน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พัฒน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "์"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผบ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ก."
      },
      {
          "pos": "PUNCT",
          "role": null,
          "token": "น."
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "8"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เปิดเผย"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เบื้องต้น"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เป็น"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "การจับกุม"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ตาม"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หมายจับ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เนื่องจาก"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พยานหลักฐาน"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "เพียง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พอให้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ศาล"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "เชื่อได้"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ก่อเหตุ"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "มีความผิด"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "จริง"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ถึงแม้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "มา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พบ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พนักงานสอบสวน"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "แต่"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เมื่อ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หมายจับ"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "แล้ว"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ก็"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ต้อง"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ถือว่า"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เป็น"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "การจับกุม"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ตาม"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หมายจับ"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "เบื้องต้น"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "ตั้งข้อหา"
      },
      {
          "pos": "NOUN",
          "role": "charge",
          "token": "ร่วมกันฆ่าผู้อื่นโดยเจตนา"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ความผิด"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "เกี่ยวกับ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "พ.ร.บ."
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อาวุธ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ภายหลัง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เจ้าหน้าที่ตำรวจ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "นำ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ตัว"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "ทั้งสอง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "เข้าไป"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "สอบปากคำ"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ภายใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ห้อง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "สอบสวน"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "นาน"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "เกือบ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "1"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ชั่วโมง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้บังคับการ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ตำรวจนครบาล"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "8"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ให้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ข้อมูล"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ให้การ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "รับสารภาพ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เป็น"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ก่อเหตุ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ยิง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้เสียชีวิต"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "จริง"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "โดย"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "อาวุธ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ใช้"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เป็น"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อาวุธ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "PART",
          "role": null,
          "token": "ไม่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ทะเบียน"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "นำมา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เก็บรักษา"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ไว้"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "บ้าน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ที่เกิดเหตุ"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "โดย"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้เสียชีวิต"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "การ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ท้าทาย"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "นัดหมาย"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จะ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "นำ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หลานสาว"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "มา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ส่ง"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ให้"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "บ้าน"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "วันเกิดเหตุ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เมื่อ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ฝั่ง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้เสียชีวิต"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มาถึง"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ก็"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มีปากเสียง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ทะเลาะวิวาท"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "กัน"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "จน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เกิด"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "การ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ชุลมุน"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "กัน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ขึ้น"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "แต่"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ก็"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "แยกย้าย"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "กัน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "กระทั่ง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้เสียชีวิต"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ออกจาก"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "บ้าน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ไป"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พบ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "PRON",
          "role": null,
          "token": "ตัวเอง"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ถูก"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "แทง"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เข้าที่"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ท้อง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ด้าน"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "ซ้าย"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จึง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ให้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "อีก"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "1"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คน"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ซึ่ง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เป็น"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ขี่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "รถจักรยานยนต์"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พา"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ไป"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ส่ง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "โรงพยาบาล"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "อ้างว่า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เกรง"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จะ"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ถูก"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ฝั่ง"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ของ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้เสียชีวิต"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "รุม"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "ทำร้าย"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จึง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พกอาวุธ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ไป"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ด้วย"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เมื่อ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พบ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้เสียชีวิต"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ยืน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "อยู่"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หน้า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปากซอย"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จึง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เกิด"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ความรู้สึก"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "แค้น"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "โดน"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "ทำร้าย"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จึง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ใช้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อาวุธ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ยิง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้เสียชีวิต"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ก่อน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จะ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "หลบหนี"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ไป"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ก่อน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จะ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "นำ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "อาวุธ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ไป"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "โยนทิ้ง"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คลอง"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "ห่าง"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "จาก"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "จุด"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เกิดเหตุ"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ไปหา"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ตั้งหลัก"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "เพื่อ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ต่อ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "สู้คดี"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "ทั้งนี้"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เมื่อ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ชุด"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "สอบสวน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ถามถึง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ประเด็น"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เกี่ยวข้อง"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "กับ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ความสัมพันธ์"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ครอบครัว"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หลานสาว"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ก็"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ปล่อยโฮ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ร้องไห้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ฟูมฟาย"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ด้วย"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ความ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "น้อยเนื้อต่ำใจ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เพราะ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หลานสาว"
      },
      {
          "pos": "PART",
          "role": null,
          "token": "ไม่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "รัก"
      },
      {
          "pos": "PART",
          "role": null,
          "token": "ไม่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เชื่อฟัง"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ติด"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เพื่อน"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หนี"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ออกจาก"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "บ้าน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ไป"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "อยู่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "บ้าน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คนอื่น"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ยอมรับ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ที่ผ่านมา"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ได้"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "การ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ลงโทษ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "หลานสาว"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "แต่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เป็น"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ด้วย"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ความรัก"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เป็น"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ห่วงใย"
      },
      {
          "pos": "PART",
          "role": null,
          "token": "ไม่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ใช่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "การทำร้ายร่างกาย"
      },
      {
          "pos": "PART",
          "role": null,
          "token": "อย่าง"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คู่กรณี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "กล่าวอ้าง"
      },
      {
          "pos": "ADJ",
          "role": null,
          "token": "เบื้องต้น"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "ตำรวจ"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ได้"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "แจ้ง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ข้อกล่าวหา"
      },
      {
          "pos": "NOUN",
          "role": "charge",
          "token": "ร่วมกันฆ่าผู้อื่นโดยเจตนา"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ส่วน"
      },
      {
          "pos": "NOUN",
          "role": "charge",
          "token": "ข้อหาที่เกี่ยวข้องกับอาวุธปืนที่ไม่มีทะเบียน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ชุด"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "สืบสวนสอบสวน"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "จะ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "รอ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ให้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เจ้าหน้าที่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "งม"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ปืน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "กระบอก"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "ดังกล่าว"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ขึ้น"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "มา"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "ได้เสีย"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ก่อน"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "เมื่อ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ตรวจสอบ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "เป็นจริง"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ตาม"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คำให้การ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ก็"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "จะแจ้ง"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ข้อกล่าวหา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เพิ่ม"
      },
      {
          "pos": "ADV",
          "role": null,
          "token": "อีก"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "หนึ่ง"
      },
      {
          "pos": "PUNCT",
          "role": null,
          "token": "ข้อหา"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "ทั้งนี้"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คดี"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "ดังกล่าว"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ต้องหา"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ที่"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ถูก"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ออกหมายจับ"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "2"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "คือ"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ตัว"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ผู้ลงมือ"
      },
      {
          "pos": "CCONJ",
          "role": null,
          "token": "และ"
      },
      {
          "pos": "PRON",
          "role": null,
          "token": "ผู้"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "ขี่"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "รถจักรยานยนต์"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "อีก"
      },
      {
          "pos": "NUM",
          "role": null,
          "token": "1"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "คน"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ซึ่ง"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ชั้น"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "การ"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "สืบสวนสอบสวน"
      },
      {
          "pos": "ADP",
          "role": null,
          "token": "ใน"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "ชั้นนี้"
      },
      {
          "pos": "AUX",
          "role": null,
          "token": "ยัง"
      },
      {
          "pos": "PART",
          "role": null,
          "token": "ไม่"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "พบ"
      },
      {
          "pos": "SCONJ",
          "role": null,
          "token": "ว่า"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มี"
      },
      {
          "pos": "NOUN",
          "role": null,
          "token": "บุคคล"
      },
      {
          "pos": "DET",
          "role": null,
          "token": "อื่น"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เข้ามา"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "มีส่วน"
      },
      {
          "pos": "VERB",
          "role": null,
          "token": "เกี่ยวข้อง"
      }
  ],
  "type": "summary"
}